var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boder-box"},[_c('span',{staticClass:"boder-box-title"},[_c('el-checkbox',{attrs:{"title":"全/反选"},on:{"change":_vm.checkAllChange}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }